// extracted by mini-css-extract-plugin
module.exports = {"title":"_0fb731"};